export default __webpack_public_path__ + "web/react/components/follow-designer-send-to-app-modal/images/follow-image3.59b38d4e92090ce53b0d4d9ef0a1a704.png";